import { render, staticRenderFns } from "./CafeSupport.vue?vue&type=template&id=6dfd3a7a&"
import script from "./CafeSupport.vue?vue&type=script&lang=js&"
export * from "./CafeSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6dfd3a7a', component.options)
    } else {
      api.reload('6dfd3a7a', component.options)
    }
    module.hot.accept("./CafeSupport.vue?vue&type=template&id=6dfd3a7a&", function () {
      api.rerender('6dfd3a7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/CafeSupport.vue"
export default component.exports